import { EFreightForShipperStatus } from '@okcargo-apps/shared-domain';
import { FreightStatus } from '@okcargo/query-processor';

export function transformToEFreightForShipperStatus(
  freightStatusResponse: FreightStatus,
  isAnyStopStartedOrFinished: boolean,
  priceForShipper?: number,
  offerAcceptedAt?: Date,
): EFreightForShipperStatus {
  console.log('freightStatusResponse', freightStatusResponse);
  console.log('isAnyStopStartedOrFinished', isAnyStopStartedOrFinished);
  console.log('priceForShipper', priceForShipper);
  console.log('offerAcceptedAt', offerAcceptedAt);

  switch (freightStatusResponse) {
    case FreightStatus.PLANNING: // it should not be received if it is as a carrier, it should be received if it is as a shipper
    case FreightStatus.CREATED:
    case FreightStatus.ACCEPTED:
    case FreightStatus.PENDING:
    case FreightStatus.ASSIGNED:
      if (offerAcceptedAt) {
        return isAnyStopStartedOrFinished ? EFreightForShipperStatus.ON_ROUTE : EFreightForShipperStatus.ASSIGNED;
      } else {
        if (priceForShipper && priceForShipper > 0) {
          return EFreightForShipperStatus.OFFER_SENT;
        } else {
          return EFreightForShipperStatus.OFFER_REQUESTED;
        }
      }

    case FreightStatus.STARTED:
    case FreightStatus.ARRIVED:
    case FreightStatus.WORKING_START:
    case FreightStatus.WORKING_END:
    case FreightStatus.ON_ROUTE:
      return EFreightForShipperStatus.ON_ROUTE;

    case FreightStatus.FINISHED:
    case FreightStatus.FINISHED_BY_CARRIER:
    case FreightStatus.FINISHED_BY_SHIPPER:
    case FreightStatus.FINISHED_WITH_ISSUE:
    case FreightStatus.FINISHED_WITH_ISSUE_SOLVED:
      return EFreightForShipperStatus.FINISHED;

    case FreightStatus.CANCELLED:
    case FreightStatus.ABORTED: // but should not be received: in this state there would never have been an assignment to a carrier
    case FreightStatus.CANCELLED_BY_CARRIER:
    case FreightStatus.CANCELLED_BY_SHIPPER:
    case FreightStatus.OFFER_REJECTED:
      return EFreightForShipperStatus.CANCELLED;

    case FreightStatus.OFFER_REQUESTED:
      return EFreightForShipperStatus.OFFER_REQUESTED;

    case FreightStatus.OFFER_SENT:
      return EFreightForShipperStatus.OFFER_SENT;

    case FreightStatus.DRAFT:
    case FreightStatus.REJECTED:
    case FreightStatus.NO_SHOW_BY_CARRIER:
    case FreightStatus.NO_SHOW_BY_SHIPPER:
    case FreightStatus.DELETED:
      return EFreightForShipperStatus.DELETED;
  }
}
